<template>
    <div class="slks-input" :class="{ 'slks-input--light': light }">
        <label data-testid-label v-if="modelValue" class="slks-input-label">{{ label }}</label>
        <input
            data-testid-input
            :type="type"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :placeholder="label"
            :class="{ invalid: invalid }"
            @focus="$emit('keyboard')"
            @blur="$emit('keyboard')"
        />
        <Alert v-if="invalid" :message="errorMessage" />
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Alert from "./Alert.vue";

export default defineComponent({
    name: "TextInput",
    components: { Alert },
    emits: ["update:modelValue", "keyboard"],
    props: {
        modelValue: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: "text",
        },
        label: {
            type: String,
            required: true,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        light: {
            type: Boolean,
            default: false,
        },
        errorMessage: String,
    },
});
</script>

<style lang="scss" scoped>
@import "@/styles/colors.scss";
@import "@/styles/mixins.scss";

.slks-input {
    position: relative;
    input {
        border: solid 2px $slks-dark-alt;
        padding: 0.875rem 1.125rem;
        font-size: 1.125rem;
        background-color: $slks-white;
        width: 100%;
        position: relative;
        outline: none;
        &.invalid {
            border: solid 2px $slks-error;
        }
        &:focus-visible {
            border: solid 2px $slks-silver;
            & + .alert {
                display: none;
            }
        }
    }
    &-label {
        position: absolute;
        top: -0.625rem;
        left: 0.5rem;
        color: rgba($slks-dark-alt, 0.46);
        font-size: 1rem;
        font-weight: 300;
        padding: 0 0.5rem;
        background-color: $slks-white;
        z-index: 10;
    }
    &--light {
        input {
            color: $slks-white;
            border: solid 2px $slks-white;
            background-color: $slks-dark;
            &.invalid {
                border: solid 2px $slks-error;
            }
            &:focus-visible {
                border: solid 2px $slks-silver;
            }
        }
        .slks-input-label {
            color: rgba($slks-white-alt, 0.46);
            background-color: $slks-dark;
        }
    }
}
</style>
